export enum ContractsRoutesEnum{
    PREFIX              = 'CONTRACTS',
    CONTRACTS_LIST      = 'CONTRACTS_LIST',
    CONTRACTS_DETAIL    = 'CONTRACTS_DETAIL',
}